import { ProcessTemplate } from "processTemplates/model/ProcessTemplate";
import { ElementType, IElementDictionary, IManualTriggerParameter, IProcessData } from "./IProcessData";

export class Process {
    public id: number;
    public name: string;
    public tagString: string;
    public description: string;
    public uniqueIdentifier: string | undefined;
    public version: number | undefined;
    public changeDescription: string;
    public triggers: any[];
    public bpmn: string;
    public elementParameters: IElementDictionary;
    public isNotLatestVersion: boolean | undefined;
    public majorVersion: number | undefined;
    public minorVersion: number | undefined;
    public isDraft: boolean | undefined;
    public idOfBaseProcessForDraft?: number;
    public modified: string | undefined;
    public modifier: string | undefined;
    public manualTrigger: IManualTriggerParameter[];
    public isSubprocess: boolean | undefined;
    public isMigration: boolean | undefined;
    public hasGlobalErrorHandler: boolean;
    public apiSpecId: number | null;
    public frendsVersion: string | undefined;
    public targetFramework: string;
    public isForMonitoringRule: boolean;
    public cancellationDisabled: boolean;
    public processTemplate: ProcessTemplate | undefined;
    public processTemplateDeviated: Date | undefined;
    public ignoreDependencyConflicts: boolean | undefined;
    public documentationMarkdown: string | undefined;
    constructor(data?: IProcessData) {
        // defaults
        this.triggers = [];
        this.tagString = "";
        this.majorVersion = 0;
        this.minorVersion = 1;
        this.changeDescription = "";
        this.manualTrigger = [];
        this.targetFramework = "net471";
        this.ignoreDependencyConflicts = false;
        if (data) {
            // if data set -> init from there
            this.id = data.id;
            this.name = data.name;
            this.tagString = data.tagString;
            this.description = data.description;
            this.uniqueIdentifier = data.uniqueIdentifier;
            this.version = data.version;
            this.isNotLatestVersion = data.isNotLatestVersion;
            this.majorVersion = data.majorVersion;
            this.minorVersion = data.minorVersion;
            this.bpmn = data.bpmn;
            this.isDraft = data.isDraft;
            this.idOfBaseProcessForDraft = data.idOfBaseProcessForDraft;
            this.modified = data.modified;
            this.modifier = data.modifier;
            this.manualTrigger = data.manualTrigger ? data.manualTrigger : this.manualTrigger;
            this.isSubprocess = data.isSubprocess;
            this.isMigration = data.isMigration;
            this.hasGlobalErrorHandler = data.elementParameters.some((x) => x.type === ElementType.GlobalErrorHandler);
            this.apiSpecId = data.apiSpecId;
            this.frendsVersion = data.frendsVersion;
            this.targetFramework = data.targetFramework ? data.targetFramework : this.targetFramework;
            this.isForMonitoringRule = data.isForMonitoringRule ? data.isForMonitoringRule : this.isForMonitoringRule;
            this.cancellationDisabled = data.cancellationDisabled ? data.cancellationDisabled : false;
            this.processTemplate = data.processTemplate;
            this.processTemplateDeviated = data.processTemplateDeviated;
        }
    }
}

// tslint:disable-next-line:max-classes-per-file
export class Tag {
    constructor(public text: string) { }
}
